<template>
  <div>
    <!-- Month Nav -->
    <div class="w3-display-container w3-center w3-padding">
      <button type="button" class="w3-button w3-display-left btnBack" @click="previousMonth()"><i class="fa fa-chevron-left"></i></button>
      <h5>{{monthTitle}} {{year}}</h5>
      <button type="button" class="w3-button w3-display-right btnNext" @click="nextMonth()"><i class="fa fa-chevron-right"></i></button>
    </div>
    <!-- Calendar Display -->
    <div class="w3-padding-8 flowGrid col7 w3-center w3-light-grey pointer outline">
      <div>Su</div>
      <div>Mo</div>
      <div>Tu</div>
      <div>We</div>
      <div>Th</div>
      <div>Fr</div>
      <div>Sa</div>
    </div>
    <div class="whiteContainer pointer noSelect">
      <div v-for="(day, index) in daysOfMonth" :key="index" class="flowGrid calendarGrid col7 gap0 w3-center">
        <div class="w3-padding gridBorder" v-for="(dayOfWeek, index) in day.days" :key="index" @click="setStartDate(dayOfWeek)" :class="activeDay(dayOfWeek)">
          {{dayOfWeek | dateSelect({day: '2-digit'})}}
        </div>
      </div>
    </div>
    <!-- Selected Date Bar -->
    <div class="w3-padding-8 w3-center w3-border-top w3-white w3-text-teal" v-if="selectedStart">
      Selected: {{selectedStart | dateSelect({month:'2-digit', day:'2-digit', year:'2-digit'})}}
    </div>
  </div>
</template>

<script>
  import * as moment from 'moment'

  export default {
    name: 'dateSelect',
    created() {
      this.setStartDate(moment())
    },
    data() {
      return {
        startDay: moment().startOf('month').startOf('week'),
        selectedStart: moment().format(),
        endDay: moment().endOf('month').endOf('week'),
        monthOffset: 0,
        monthTitle: moment().format('MMMM'),
        year: moment().format('YYYY')
      }
    },
    computed: {
      daysOfMonth() {
        let calendar = []
        let date = this.startDay.clone().subtract(1, 'day')
        while (date.isBefore(this.endDay, 'day')) {
          calendar.push({
            days: Array(7).fill(0).map(() => date.add(1, 'day').clone())
          })
        }
        return calendar
      },
      selectedEnd() {
        return moment(this.selectedStart).add(1, 'hours')
      }
    },
    methods: {
      nextMonth() {
        let nowMonth = moment().add(this.monthOffset, 'months')
        this.startDay = moment(nowMonth).add(1, 'months').startOf('month').startOf('week')
        this.endDay = moment(nowMonth).add(1, 'months').endOf('month').endOf('week')
        this.monthTitle = moment(nowMonth).add(1, 'months').format('MMMM')
        this.year = moment(nowMonth).add(1, 'months').format('YYYY')
        this.monthOffset++
      },
      previousMonth() {
        let nowMonth = moment().add(this.monthOffset, 'months')
        this.startDay = moment(nowMonth).subtract(1, 'months').startOf('month').startOf('week')
        this.endDay = moment(nowMonth).subtract(1, 'months').endOf('month').endOf('week')
        this.monthTitle = moment(nowMonth).subtract(1, 'months').format('MMMM')
        this.year = moment(nowMonth).subtract(1, 'months').format('YYYY')
        this.monthOffset--
      },
      startDate(date) {
        if (!moment(date).isSame(this.selectedStart, 'month')) {
          return 'w3-text-light-grey'
        }
        if (moment(date).isSame(this.selectedStart, 'day')) {
          return 'w3-dark-blue'
        } else {
          return
        }
      },
      activeDay(date) {
        let startDay = moment(this.selectedStart).startOf('day')
        let endDay = moment(this.selectedEnd).startOf('day')
        if (moment(date).isBetween(startDay, endDay, 'days', '[]')) {
          return 'w3-dark-blue'
        } else {
          if (moment(date).isBetween(moment().startOf('day'), endDay, 'days', '[]')) {
            return 'w3-medium-grey'
          }
          if (!moment(date).isSame(moment().add(this.monthOffset, 'months'), 'month')) {
            return 'w3-text-light-grey'
          }
          return
        }
      },
      setStartDate(date) {
        // if (this.selectedEnd && moment(date).isAfter(this.selectedEnd)) {
        //   return
        // }
        if (moment(date).isBefore(moment().startOf('day'))) {
          alert('Start date cannot be before today: ' + moment().format('MM/DD/YYYY'))
          return
        }
        this.selectedStart = moment(date).format()
        this.$emit('set-start-date', this.selectedStart)
      }
    }
  }
</script>

<style scoped>
.flowGrid {display: grid; grid-gap: 8px 16px;}
.flowGrid.col7 {grid-template-columns: repeat(7, 1fr);}
.gap0 {column-gap: 0}

.gridBorder:not(:nth-child(7n)) {border-right:1px solid #ccc;}
.calendarGrid:not(:nth-last-child(-n + 1)) {border-bottom:1px solid #ccc;}

.noSelect {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/dateSelect.vue